import React, { Component } from 'react'
import '../styles/CreatedClusters.css'
import DropdownWidget from '../widgets/DropdownWidget'
import InputTextFilterWidget from '../widgets/InputTextFilterWidget'
import InputSearchWidget from '../widgets/InputSearchWidget'
import APIClusterRequest from '../api/APIClusterRequest'
import APIFarmerRequest from '../api/APIFarmerRequest'
import DatePicker from '../widgets/DatePicker'
import ActivityIndicator from '../widgets/ActivityIndicator'

class CreatedClusters extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			siteId: JSON.parse(localStorage.getItem("siteId")),
			accountType: props.type,
			site: props.site,
		}
		this.onRegisterClick = this.onRegisterClick.bind(this)
		this.viewDetails = this.viewDetails.bind(this)
		this.handleSearch = this.handleSearch.bind(this)
		this.filterByDate = this.filterByDate.bind(this)
		this.filterByStatusId = this.filterByStatusId.bind(this)
	}

	viewDetails(id, name) {
		this.props.viewDetails("view-details", id, name)
	}

	componentWillMount() {
		this.setState({showActivityIndicator: true})
		const clusters = APIClusterRequest.getAllClustersBySiteId(this.state.accessToken, this.state.siteId)
		clusters.then((response) => {
			console.log('getAllClustersBySiteId', response)
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return
			}
			const datesFormed = {}
			let id = 2
			for(const v of response.results.rows) {
				datesFormed[v.date_formed] = {id: id++, name: formatDate(v.date_formed)}
			}
			const df = []
			df.push({id: 0, name: "ANY"})
			df.push({id: 1, name: "CUSTOM"})
			for(const k in datesFormed) {
				df.push(datesFormed[k])
			}
			let items = {}
			// TEMPORARY SOLUTION TO REDUNDANT CLUSTER ITEMS
			response.results.rows.map((item, i) => {
				if(!items.hasOwnProperty(item.cluster_id)) {
					items[item.cluster_id] = item
				}
			})
			const listData = Object.values(items)
			console.log('listData', listData)
			// const list = response.results.rows
			listData.sort((a, b) => {
				return(a.cluster_name.localeCompare(b.cluster_name))
			})
			this.setState({
				showActivityIndicator: false,
				allClusters: response.results.rows,
				datesFormed: df,
				listData: listData //response.results.rows
			})
		})
	}

	onRegisterClick() {
		this.props.onRegisterClick("create")
	}

	handleSearch(searchVal) {
		if(searchVal == null || this.state.allClusters == null) {
			this.setState({listData: null})
			return
		}
		const byTarget = []
		for(const v of this.state.allClusters) {
			if(searchVal.cropId == 0 || searchVal.cropId == null) {
				byTarget.push(v)
			}
			else {
				if(searchVal.crop === v.crop) {
					byTarget.push(v)
				}
			}
		}
		const dateSelected = {
			dateFormed: searchVal.dateFormed,
			dateFrom: searchVal.dateFrom,
			dateTo: searchVal.dateTo
		}
		if(searchVal.statusId != null && searchVal.statusId !== "") {
			this.filterByStatusId(searchVal.statusId, byTarget, (at) => {
				this.filterByDate(dateSelected, at, (bd) => {
					this.setState({listData: bd})
				})
			})
			return
		}
		this.filterByDate(dateSelected, byTarget, (bd) => {
			this.setState({listData: bd})
		})
	}

	filterByStatusId(statId, crops, callback) {
		const at = []
		for(const v of crops) {
			if(statId == v.is_active) {
				at.push(v)
			}
		}
		callback(at)
	}

	filterByDate(dateSelected, clusters, callback) {
		const dr = new Date(dateSelected.dateFormed)
		const df = new Date(dateSelected.dateFrom)
		const dt = new Date(dateSelected.dateTo)
		const cls = []
		for(const v of clusters) {
			const ds = new Date(v.date_formed)
			if(dateSelected.dateFormed == null) {
				cls.push(v)
				continue
			}
			if(dateSelected.dateFormed.toLowerCase() === "any") {
				cls.push(v)
			}
			else if(dr.getMonth() === ds.getMonth() && dr.getDate() === ds.getDate() && dr.getFullYear() === ds.getFullYear()) {
				cls.push(v)
			}
			else if(ds >= df && ds < dt) {
				cls.push(v)
			}
		}
		callback(cls)
	}

	render() {
		return(<div id="created-clusters">
			<div id="cc-search"><SearchClusters datesFormed={this.state.datesFormed}
				submitSearch={this.handleSearch} /></div>
			<div id="cc-listview"><ClustersListView data={this.state.listData}
				onRegisterClick={this.onRegisterClick}
				viewDetails={this.viewDetails} />
			</div>
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>)
	}
}

class SearchClusters extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			maxDate: sessionStorage.getItem("date-today"),
			crop: "ANY",
			status: "ANY",
			dateFormed: "ANY",
			isDisabled: true,
			statuses: [
				{id: null, name: "ANY"},
				{id: 0, name: "INACTIVE"},
				{id: 1, name: "ACTIVE"}
			]
		}
		this.getAllCrops = this.getAllCrops.bind(this)
	}

	componentWillMount() {
		this.getAllCrops()
	}

	componentDidUpdate(prevProps) {
		if(prevProps.datesFormed != this.props.datesFormed) {
			var dateMin = new Date()
			for(const v of this.props.datesFormed) {
				if(v != null) {
					const d = v.name.split("/")
					var dm = d[2] + "-" + d[0] + "-" + d[1]
					const dmDO = new Date(dm)
					if(dmDO < dateMin) {
						dateMin = dmDO
					}
				}
			}
			let month = String(dateMin.getMonth()+1), day = String(dateMin.getDate());
			month = (month.length < 2)? '0'+ month: month;
			day = (day.length < 2)? '0'+ day: day;
			this.setState({
				datesFormed: this.props.datesFormed,
				dateMin: dateMin.getFullYear() +'-'+ month +'-'+ day,
				clusters: this.props.clusters
			})
		}
	}

	getAllCrops() {
		const types = APIFarmerRequest.getAllCrops(this.state.accessToken)
		types.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			c.push({id: 0, name: "ANY"});
			for(const v of response.results.rows) {
				c.push({id: v.crop_id, name: v.name})
			}
			// localStorage.setItem("crops", JSON.stringify(c))
			this.setState({crops: c})
		})
	}

	render() {
		return(<div className="search-bar">
			<div>SEARCH BY</div>
			<br/>
			<div style={{'margin-bottom': '5px'}}>Target Crop</div>
			<InputTextFilterWidget list={this.state.crops} placeholder={this.state.targetCrop}
				onItemSelected={(id, val) => {
					this.setState({cropId: id, crop: val})
				}} cStyle={{"width": "100%"}} disabled={this.state.disabled} />
			{/* <DropdownWidget placeholder={this.state.crop} list={this.state.crops} onItemSelected={(id, value) => {
				this.setState({
					cropId: id,
					crop: value,
				})
			}} /> */}
			<br/><br/>
			<div style={{'margin-bottom': '5px'}}>Date Registered</div>
			<DropdownWidget placeholder={this.state.dateFormed} list={this.state.datesFormed} cStyle={{'min-width': '100%'}} onItemSelected={(id, value) => {
				let isDisabled = true
				let dateFrom = ""
				let dateTo = ""
				let isCustom = false
				if(id == 1) {
					isDisabled = false
					dateFrom = this.state.dateMin
					dateTo = this.state.maxDate
					isCustom = true
				}
				this.setState({
					dateFormed: value,
					isDisabled: isDisabled,
					dateFrom: dateFrom,
					dateTo: dateTo,
					isCustom: isCustom
				})
			}} />
			{this.state.isCustom && <div className="sb-date"><div className="sb-date-lbl">From</div>
				<div className="sb-date-cl">
					<DatePicker name="from" max={this.state.maxDate} value={this.state.dateFrom} onChange={(value) => {
						this.setState({dateFrom: value})
					}} disabled={this.state.isDisabled} />
				</div>
			</div>}
			{this.state.isCustom && <div className="sb-date"><div className="sb-date-lbl" style={{'text-align': 'right'}}>To</div>
				<div><DatePicker name="to" max={this.state.maxDate} value={this.state.dateTo} onChange={(value) => {
					this.setState({dateTo: value})
				}} disabled={this.state.isDisabled} /></div>
			</div>}
			{/* <br/><br/>
			<div>Status</div>
			<DropdownWidget list={this.state.statuses} onItemSelected={(id, value) => {
				this.setState({
					statusId: id,
					status: value,
				})
			}} placeholder={this.state.status} cStyle={{'min-width': '100%'}} /> */}
			<br/>
			<button className="green-two" onClick={(e) => {
				const filter = {
					crop: this.state.crop,
					cropId: this.state.cropId,
					dateFormed: this.state.dateFormed,
					dateFrom: this.state.dateFrom,
					dateTo: this.state.dateTo,
					status: this.state.status,
					statusId: this.state.statusId
				}
				this.props.submitSearch(filter)
			}}>SEARCH</button>
			<button className="green-two" onClick={(e) => {
				this.setState({
					crop: "ANY",
					cropId: null,
					dateFormed: "ANY",
					dateFrom: "",
					dateTo: "",
					status: "ANY",
					statusId: null
				})
				this.props.submitSearch(null)
			}}>CLEAR</button>
		</div>)
	}
}

class ClustersListView extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			searchLabel: (props.data != null)? props.data.count + " result(s)": "PRESS THE SEARCH BUTTON TO SEE RESULTS",
			listItems: [],
			onRegisterClick: props.onRegisterClick
		}
		this.viewDetails = this.viewDetails.bind(this)
		this.onSearchEvent = this.onSearchEvent.bind(this)
	}

	viewDetails(id, name) {
		this.props.viewDetails(id, name)
	}

	componentDidUpdate(prevProps) {
		if(prevProps.data != this.props.data) {
			const listItems = []
			if(this.props.data != null) {
				for(const v of this.props.data) {
					listItems.push(<ListItem data={v} viewDetails={this.viewDetails} key={Math.random()} />)
				}
			}
			this.setState({
				searchLabel:  (this.props.data != null)? this.props.data.length + " RESULT(S)": "PRESS THE SEARCH BUTTON TO SEE RESULTS",
				listItems: listItems
			})
		}
	}

	onSearchEvent(value) {
		if(this.props.data == null) {
			return
		}
		const sr = searchString(value, this.props.data)
		if(sr == null) {
			return
		}
		const listItems = []
		for(const v of sr) {
			listItems.push(<ListItem data={v} viewDetails={this.viewDetails} />)
		}
		this.setState({
			searchLabel:  sr.length + " RESULT(S)",
			listItems: listItems
		})
	}

	render() {
		return(<div className="clusters-lv">
			<div className="clv-top">
				<InputSearchWidget placeholder="SEARCH RESULTS" cStyle={{'width': '285px'}}
					onSearchClick={(value) => {
						this.onSearchEvent(value)
					}}
					onEnterPress={(value) => {
						this.onSearchEvent(value)
					}} />
				<div className="clv-label"><div>{this.state.searchLabel}</div></div>
			</div>
			<div className="clv-header">
				<table className="clv-table-header">
					<col style={{width: '25%'}} />
					<col style={{width: '45%'}} />
					<col style={{width: '15%'}} />
					<col style={{width: '15%'}} />
					<tr>
						<th>CLUSTER NAME</th>
						<th>CLUSTER LEADER</th>
						<th>DATE FORMED</th>
						<th>STATUS</th>
						<div className="clv-grid-btn"><button className="green-two" onClick={(e) => {
								this.state.onRegisterClick()
							}}>ADD CLUSTER</button>
						</div>
					</tr>
				</table>
			</div>
			<div className="clv-items">{this.state.listItems}</div>
			{this.state.listItems.length < 1 && <div className="clv-result"><div>NO RESULT</div></div>}
		</div>)
	}
}

function ListItem(props) {
	let mi = ''
	if(props.data.middle_name != null) {
		mi = `${props.data.middle_name.charAt(0)}.`
	}
	const extn = (props.data.extension_name != null)? props.data.extension_name: ""
	// let name = props.data.first_name + " " + mi + ". " + props.data.last_name + " " + extn
	let name = `${props.data.last_name}, ${props.data.first_name} ${extn} ${mi}`
	if(props.data.last_name == null) {
		name = "NO CLUSTER LEADER"
	}
	return(<div className="clv-list-item">
			<table className="clv-table-data">
			<col style={{width: '25%'}} />
					<col style={{width: '45%'}} />
					<col style={{width: '15%'}} />
					<col style={{width: '15%'}} />
				<tr>
					<td>{props.data.cluster_name.toUpperCase()}</td>
					<td>{name.toUpperCase()}</td>
					{/* <td>{props.data.crop}</td> */}
					<td>{formatDate(props.data.date_formed)}</td>
					<td>{status[props.data.is_active]}</td>
					<div className="clv-grid-btn"><button className="btn-view-details" onClick={(e) => {
							props.viewDetails(props.data.cluster_id, props.data.cluster_name)
						}}>VIEW DETAILS</button>
					</div>
				</tr>
			</table>
	</div>)
}

const status = ["INACTIVE", "ACTIVE"]

const formatDate = (d) => {
	const date = new Date(d)
	var m = date.getMonth()+1
	if(date.getMonth() < 9) {
		m = "0" + (date.getMonth()+1)
	}
	var dt = date.getDate()
	if(date.getDate() < 9) {
		dt = "0" + date.getDate()
	}
	return(m + "/" + dt + "/" + date.getFullYear())
}

const searchString = (str, data) => {
	if(data.length < 1) {
		return
	}
	if(str == null) {
		str = ""
	}
	const list = []
	for(const v of data) {
		const name = v.first_name + " " + v.middle_name + " " + v.last_name + " " + v.extension_name
		if(name.toLowerCase().includes(str.toLowerCase()) || v.cluster_name.toLowerCase().includes(str.toLowerCase())) {
			list.push(v)
		}
	}
	return(list)
}

export default CreatedClusters
